import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Alert, Box, CircularProgress } from '@mui/material';
import { PageWrapper } from '../../styledComponents/wrappers';
import LpuOrderDetailLayout from '../fulfillment/LpuOrderDetailLayout';
import { LpuOrder } from '../../services/fulfillment/types';
import { confirmPickup, getLpuOrder } from '../../services/fulfillment/lpuApi';
import { LPU_PICKUP_LIST_ROUTE } from './LpuPickupOrdersList';

const LpuPickupDetail: React.FC = () => {
  const { orderId } = useParams<{ orderId: string }>();
  const [order, setOrder] = useState<LpuOrder | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const id = parseInt(orderId, 10);
    getLpuOrder(id)
      .then(o => {
        if (!o) {
          setError('Order not found.');
          return;
        }
        setOrder(o);
      })
      .finally(() => setLoading(false));
  }, [orderId]);

  if (loading || !order) {
    return (
      <PageWrapper>
        {error ? (
          <Alert severity="error">{error}</Alert>
        ) : (
          <Box display="flex" justifyContent="center" mt={4}>
            <CircularProgress />
          </Box>
        )}
      </PageWrapper>
    );
  }

  return (
    <LpuOrderDetailLayout
      order={order}
      pageTitle="Confirm Pickup"
      instruction="Verify customer identity / order confirmation. Confirm all items are present before handoff."
      actionLabel="Confirm Pickup"
      actionInProgressLabel="Confirming…"
      successHeading="Pickup Confirmed!"
      successInstruction="Order has been fulfilled and inventory adjusted."
      backLabel="Local Pickup Orders"
      backRoute={LPU_PICKUP_LIST_ROUTE}
      onAction={() => confirmPickup(order.shopifyOrderId)}
    />
  );
};

export default LpuPickupDetail;
